import React from 'react'
const WhitePaper3 = () => {
    document.getElementsByTagName("body")[0].style.overflow = "hidden"
    document.getElementsByTagName("html")[0].style.overflow = "hidden"
    return (

        <div style={{ height: '100vh', overflow:"hidden", margin:0}}>
            <iframe title={"pdf viewer"} src="https://big-events.itools.etermax.com/" width='100%' height='100%' style={{border:"none"}} frameBorder={0} />
        </div>)
}
export default WhitePaper3
